import { createSlice } from '@reduxjs/toolkit';

const slides =[
    {
        url: 'image4.png',
        isSelected: true
    },
    {
        url: 'image5.png',
        isSelected: false
    },
    {
        url: 'image6.png',
        isSelected: false
    },
    {
        url: 'image7.png',
        isSelected: false
    }
]

const initialSlideState = {
    items: slides,
    currentSlideIndex: 0
}

const slideSlice = createSlice({
    name: 'slideshow',
    initialState: initialSlideState,
    reducers: {
        nextSlide(state, action) {
            state.items[state.currentSlideIndex].isSelected = 
                !state.items[state.currentSlideIndex].isSelected;

            if (state.currentSlideIndex === 3) {
                state.currentSlideIndex = 0;
            } else {
                state.currentSlideIndex++;
            }

            state.items[state.currentSlideIndex].isSelected = !state.items[state.currentSlideIndex].isSelected;
        },
        previousSlide(state, action) {
            state.items[state.currentSlideIndex].isSelected = 
                !state.items[state.currentSlideIndex].isSelected;

            if (state.currentSlideIndex === 0) {
                state.currentSlideIndex = 3;
            } else {
                state.currentSlideIndex--;
            }
            
            state.items[state.currentSlideIndex].isSelected = !state.items[state.currentSlideIndex].isSelected;
        },
        changeSlide(state, action) {
            const slideIndex = action.payload;
            state.currentSlideIndex = slideIndex;
        
            const previousSlideIndex = state.items.findIndex(item => !!item.isSelected);
            state.items[previousSlideIndex].isSelected = !state.items[previousSlideIndex].isSelected;
            state.items[state.currentSlideIndex].isSelected = !state.items[state.currentSlideIndex].isSelected;
        }
    }
})

export const slideActions = slideSlice.actions;

export default slideSlice.reducer;